import { render, staticRenderFns } from "./BranchPagination.vue?vue&type=template&id=46973486&"
import script from "./BranchPagination.vue?vue&type=script&lang=js&"
export * from "./BranchPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports